import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import useDebounce from '../../hooks/UseDebounce';

const SearchBar = ({ loading, setSearchTerm }) => {
  const [internalValue, setInternalValue] = useState('');
  const debouncedInternalValue = useDebounce(internalValue, 500);

  useEffect(() => {
    setSearchTerm(debouncedInternalValue);
  }, [debouncedInternalValue]);

  return (
    <div>
      {!loading && (
        <TextField
          label="Zoeken"
          variant="standard"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          onChange={event => {
            setInternalValue(event.target.value);
          }}
        />
      )}
    </div>
  );
};

export default SearchBar;
